module.exports = __webpack_public_path__ + "img/people4.e3a1912e.png";